import React, {ReactElement} from 'react'
import ReactModal, {Props} from "react-modal";

interface ModalProps extends Props {
    children: ReactElement | ReactElement[],
    width?: string | number,
    height?: string | number,
}

export default function Modal({children, width = "auto", height = "auto", ...props}: ModalProps) {
    return (
        <ReactModal  {...props} style={{
            ...props?.style,
            content: {
                ...props?.style?.content,
                width: width,
                height: height,
            }
        }}>
            {children}
        </ReactModal>
    )
}
